export enum AuthorizationStatus {
  unknown,
  pending,
  approved,
  denied,
  expired,
}
